import axios from "axios";
import { noop } from "lodash";

export const uploadTranscriptToS3 = ({
  signedURL,
  data,
  onSuccess = noop,
  onError = noop,
  onFinish = noop
}) => {
  if (signedURL) {
    axios
      .put(signedURL, data, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        console.error(error);
        onError(error);
      })
      .finally(() => {
        onFinish();
      });
  }
};

export const updateTranscriptData = ({
  transcriptS3ObjectID,
  data,
  onSuccess = noop,
  onError = noop,
  onFinish = noop
}) => {
  axios
    .get(
      `${process.env.NEXT_PUBLIC_LINX_URL}/refactor/transcript/update_signed_url`,
      {
        params: {
          transcriptS3ObjectID
        }
      }
    )
    .then((response) => {
      const signedUrlForTranscriptUpload = response?.data?.signedURL;

      uploadTranscriptToS3({
        signedURL: signedUrlForTranscriptUpload,
        data: JSON.stringify(data),
        onSuccess,
        onError,
        onFinish
      });
    });
};
